import { useEffect, useRef } from 'react';
import { useWebSocket } from './useWebSocket';
import { ChangeOrderStatusEvent } from '@interfaces/OrderTypes';
import { SOCKET_EVENTS } from '@utils/constants';
import { useScheduledOrdersActions } from '@store/actions/scheduledOrders';

export const useScheduledOrdersSocket = () => {
  const { subscribeEvent, unsubscribeEvent } = useWebSocket();
  const { removeScheduledOrder } = useScheduledOrdersActions();

  const removeRef = useRef(removeScheduledOrder);
  removeRef.current = removeScheduledOrder;

  useEffect(() => {
    const onStatusChange = ({ orderId, status }: ChangeOrderStatusEvent) => {
      // Si el nuevo estatus ya NO es 'scheduled', remover del store
      if ((status as string) !== 'scheduled') {
        removeRef.current(orderId);
      }
    };

    subscribeEvent(SOCKET_EVENTS.CHANGE_ORDER_STATUS, onStatusChange);
    return () => unsubscribeEvent(SOCKET_EVENTS.CHANGE_ORDER_STATUS, onStatusChange);
  }, []);
};
